var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("step-" + _vm.step),_vm._g({tag:"component",attrs:{"step":_vm.step,"box_init":_vm.box,"box":_vm.current_value},on:{"update:box":function($event){_vm.current_value=$event},"change-step":_vm.mixin_set_step}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }